module.exports = __webpack_public_path__ + "static/media/fundador.af186d04.jpg";